export default {
  accessorial: {},
  'brand-group': {},
  calculation: {},
  'consolidation-point': {},
  country: {},
  currency: {},
  'data-option': {},
  document: {},
  'exchange-rate': {},
  'exchange-rate-history': {},
  'financial-code': {},
  'financial-profile': {},
  'job-type': {},
  location: {},
  lookup: {},
  party: {},
  'party-group': {},
  'port-area': {},
  'point-to-port': {},
  'quote-tax': {},
  role: {},
  'routing-rules': {},
  'spreadsheet-descriptor': {},
  'spreadsheet-descriptor-parent': null,
  'transit-miles': {},
  'user-group': {},
  'mai-user': {},
  'vendor-zone': {},
  'request-for-proposal': {},
  lookupsFromDetailsSearch: [],
  lookupDetailsToggle: false,
  vendorZoneLocations: [],
  vendorZoneLocationsCount: null,
  portAreaToPorts: [],
  pointToPortToPorts: []
}



// WEBPACK FOOTER //
// ./src/modules/admin/store/state.js